import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { reservationCreate } from 'Global/Stores/reservations'
import { reservationCreateModalHide } from 'Global/Stores/modals'
import { reservationEventOptionAdd } from 'Global/Stores/options'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    eventOptions: selectors.eventOptions(state),
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
    reservations: selectors.reservations(state),
    rug: selectors.rug(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    close: () => dispatch(reservationCreateModalHide()),
    create: reservation => dispatch(reservationCreate(reservation)),
    addEventOption: option => dispatch(reservationEventOptionAdd(option)),
  })

  Enhancer.displayName = 'CreateReservationModalEnhancer'

  Enhancer.propTypes = {
    addEventOption: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    create: PropTypes.func.isRequired,
    eventOptions: PropTypes.array.isRequired,
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    reservations: PropTypes.array.isRequired,
    rug: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
